var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonLaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -1105.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Law",
    transform: "translate(1206.000000, 1105.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.441,9.6819139 L10.864,3.26388914 L5.434,13.0599269 L9.308,15.2069352 L0,32 L5.006,32 L13.138,17.3299434 L17.011,19.4769517 L22.441,9.6819139 Z M32,27.9999846 L18.905,27.9999846 C17.249,27.9999846 15.905,29.3429897 15.905,30.9999961 L15.905,32 L32,32 L32,27.9999846 Z M25.21,8.88791084 L17.806,22.2449624 C19.755,23.3269665 22.212,22.6219638 23.291,20.6719563 L26.783,14.373932 C27.863,12.4239245 27.159,9.967915 25.21,8.88791084 L25.21,8.88791084 Z M4.705,2.0348844 C5.762,0.126877036 8.164,-0.561125618 10.071,0.49587846 L2.667,13.85393 C0.759,12.7969259 0.071,10.3949166 1.128,8.4889093 L4.705,2.0348844 L4.705,2.0348844 Z",
    id: 214
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonLaw);
export default __webpack_public_path__ + "static/media/common-law.44fd7efc.svg";
export { ForwardRef as ReactComponent };